export default __webpack_public_path__ + "static/media/a036-4.9f889161.svg";